import { Map } from 'immutable'
import { createSelector } from 'reselect'
import { getCurrentUser } from 'data/users/selectors'
import { getCurrentNoteThreads } from 'data/threads/selectors'
import { ACTIVE, getStatusForEntity } from './record'
import { selectors as ThreadsSelectors } from 'data/threads'

import { getEntity, getEntityMap } from 'data'

export const getChannelActivityStatus = (state, channel) => {
  const currentUser = getCurrentUser(state)
  const fromRegistry = getEntity(
    state,
    'ChannelActivityAknowledgment',
    channel.id
  )
  return getStatusForEntity(currentUser, channel, fromRegistry)
}

export const getNoteActivityStatus = (state, note) => {
  const currentUser = getCurrentUser(state)
  const fromRegistry = getEntity(state, 'NoteActivityAknowledgment', note.id)
  const status = getStatusForEntity(currentUser, note, fromRegistry)
  return status
}

export const getActivityStatusesForCurrentNoteThreads = createSelector(
  getCurrentUser,
  state => getEntityMap(state, 'ThreadActivityAknowledgment'),
  getCurrentNoteThreads,
  (currentUser, threadActivityAknowledgments, threadList) => {
    return threadList.reduce((statuses, thread) => {
      if (!thread) {
        return statuses
      }
      const fromRegistry = threadActivityAknowledgments.get(thread.id)
      const status = getStatusForEntity(currentUser, thread, fromRegistry)
      return statuses.set(thread.id, {
        status,
        thread,
      })
    }, new Map())
  }
)

export const getActivityStatusFromThreadId = (state, threadId) => {
  const fromRegistry = getEntity(state, 'ThreadActivityAknowledgment', threadId)
  const currentUser = getCurrentUser(state)
  const thread = ThreadsSelectors.getThread(state, threadId)
  const status = getStatusForEntity(currentUser, thread, fromRegistry)
  return status
}

export const getActivityFromThreadId = (state, threadId) => {
  return getEntity(state, 'ThreadActivityAknowledgment', threadId)
}

export const areCurrentNoteCommentsActive = createSelector(
  getActivityStatusesForCurrentNoteThreads,
  threadStatuses =>
    threadStatuses.reduce(
      (isActive, { status, thread }) =>
        isActive || (status === ACTIVE && !thread.resolvedAt),
      false
    )
)
